const LOCAL_API_ORIGIN = 'http://localhost:5000';

function trimTrailingSlash(value = '') {
  return String(value || '').trim().replace(/\/+$/, '');
}

function normalizeApiBaseUrl(value = '') {
  const trimmed = trimTrailingSlash(value);
  if (!trimmed) return '';
  if (trimmed === '/api' || /\/api$/i.test(trimmed)) {
    return trimmed;
  }
  return `${trimmed}/api`;
}

function normalizeApiOrigin(value = '') {
  const trimmed = trimTrailingSlash(value);
  if (!trimmed) return '';
  return trimmed.replace(/\/api$/i, '');
}

function readWindowOverrideBaseUrl() {
  if (typeof window === 'undefined') return '';
  return String(
    window.__FUSESOUL_API_BASE_URL__
    || window.__APP_API_BASE_URL__
    || ''
  ).trim();
}

function readWindowOverrideOrigin() {
  if (typeof window === 'undefined') return '';
  return String(
    window.__FUSESOUL_API_ORIGIN__
    || window.__APP_API_ORIGIN__
    || ''
  ).trim();
}

export function getApiBaseUrl() {
  const envBaseUrl = normalizeApiBaseUrl(process.env.REACT_APP_API_BASE_URL);
  if (envBaseUrl) return envBaseUrl;

  const runtimeBaseUrl = normalizeApiBaseUrl(readWindowOverrideBaseUrl());
  if (runtimeBaseUrl) return runtimeBaseUrl;

  const envOrigin = normalizeApiOrigin(process.env.REACT_APP_API_ORIGIN);
  if (envOrigin) return `${envOrigin}/api`;

  const runtimeOrigin = normalizeApiOrigin(readWindowOverrideOrigin());
  if (runtimeOrigin) return `${runtimeOrigin}/api`;

  if (typeof window === 'undefined') {
    return `${LOCAL_API_ORIGIN}/api`;
  }

  const { protocol, hostname, origin } = window.location;
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    const localProtocol = protocol === 'https:' ? 'https:' : 'http:';
    return `${localProtocol}//${hostname}:5000/api`;
  }

  return `${origin}/api`;
}

export function getApiOrigin() {
  return normalizeApiOrigin(getApiBaseUrl());
}

export function buildApiUrl(path = '') {
  const normalizedPath = String(path || '').trim();
  if (!normalizedPath) return getApiBaseUrl();
  if (/^https?:\/\//i.test(normalizedPath)) return normalizedPath;
  if (normalizedPath.startsWith('/')) return `${getApiBaseUrl()}${normalizedPath}`;
  return `${getApiBaseUrl()}/${normalizedPath}`;
}

export function buildApiOriginUrl(path = '') {
  const normalizedPath = String(path || '').trim();
  if (!normalizedPath) return getApiOrigin();
  if (/^https?:\/\//i.test(normalizedPath)) return normalizedPath;
  if (normalizedPath.startsWith('/')) return `${getApiOrigin()}${normalizedPath}`;
  return `${getApiOrigin()}/${normalizedPath}`;
}

export const API_BASE_URL = getApiBaseUrl();
export const API_ORIGIN = getApiOrigin();
